import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';

function storageInterface(storageKey) {
  return {
    readEvents: () => JSON.parse(window.localStorage.getItem(storageKey)) || [],
    writeEvents: (events) =>
      window.localStorage.setItem(storageKey, JSON.stringify(events)),
    clearEvents: () => window.localStorage.removeItem(storageKey),
  };
}

export function match(a, b) {
  const pickBy = ['domain', 'object', 'verb'];
  return isEqual(pick(a, pickBy), pick(b, pickBy));
}

function updateCombinations(combinations, event, state) {
  let newState = state;

  combinations.forEach((combination) => {
    if (match(combination.start, event)) {
      // If the combination already exists in the state,
      // replace the start event with this newer one
      const index = newState.findIndex(
        (stateCombination) =>
          match(stateCombination.start, combination.start) &&
          match(stateCombination.end, combination.end)
      );

      if (index > -1) {
        newState = [
          ...newState.slice(0, index),
          {
            ...combination,
            start: event,
          },
          ...newState.slice(index + 1),
        ];
      } else {
        newState = [
          ...newState,
          {
            ...combination,
            start: event,
          },
        ];
      }
    }
  });

  return newState;
}

// eslint-disable-next-line no-underscore-dangle
export function _differenceTrack({ readEvents, writeEvents, clearEvents }) {
  return ({ combinations = [], persist = [], track }) => {
    let state = [];

    // Read saved events (should be from other application on the same domain) and
    // build state with those events by "playing" them through.
    readEvents().forEach((event) => {
      state = updateCombinations(combinations, event, state);
    });

    // Clear localStorage so we don't read the same events again.
    clearEvents();

    return (event) => {
      state = updateCombinations(combinations, event, state);

      const matches = state.filter((combination) =>
        match(
          {
            ...combination.end,
            clientSessionId: combination.start.clientSessionId,
          },
          event
        )
      );

      const misses = state.filter(
        (combination) =>
          !match(
            {
              ...combination.end,
              clientSessionId: combination.start.clientSessionId,
            },
            event
          )
      );

      matches.forEach((combination) => {
        const newCombination = {
          ...combination,
          end: event,
        };
        const newEvent = newCombination.event(
          newCombination.start,
          newCombination.end
        );
        setTimeout(() => track(newEvent));
      });

      state = misses;

      persist.forEach((e) => {
        if (match(e, event)) {
          let events = readEvents();
          const index = events.findIndex((ev) => match(ev, event));

          if (index > -1) {
            events = [
              ...events.slice(0, index),
              event,
              ...events.slice(index + 1),
            ];
          } else {
            events = [...events, event];
          }

          writeEvents(events);
        }
      });
    };
  };
}

export const differenceTrack = _differenceTrack(
  storageInterface('upd_difference_events')
);
